module.exports = __webpack_public_path__ + "assets/img/img-tutorial04.bee2d81a.png";